<div class="body" [formGroup]="formGroup">

    <mat-form-field appearance="fill">
        <mat-label>Bezeichnung</mat-label>
        <input matInput formControlName="title" />
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>Start</mat-label>
        <input matInput formControlName="start" type="datetime-local" />
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>Ende</mat-label>
        <input matInput formControlName="end" type="datetime-local" />
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>Kalender</mat-label>
        <mat-select formControlName="calendarIdentifier">
            <mat-option *ngFor="let calendar of (calendarService.calendars$|async)" [value]="calendar.href">
                {{calendar.name}}
            </mat-option>
        </mat-select>
    </mat-form-field>

</div>